interface TruncateTextToLinesOptions {
  text: string;
  width: number;
  maxLines: number;
  font: string;
}

export function truncateTextToLines({ text, width, maxLines, font }: TruncateTextToLinesOptions): string {
  if (!text) {
    return text;
  }

  const SAFE_WIDTH = width * 0.95;
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    return text;
  }

  ctx.font = font;

  const lines: string[] = [];
  let currentLine = '';
  // Флаг, что последняя строка должна обрезаться
  let isTruncated = false;

  const pushLine = (line: string) => {
    if (lines.length < maxLines) {
      lines.push(line);
    }
  };

  const fitWord = (word: string): boolean => {
    let rest = word;

    while (rest.length) {
      let left = 1;
      let right = rest.length;
      let fit = 1;

      while (left <= right) {
        const mid = Math.floor((left + right) / 2);

        if (ctx.measureText(rest.slice(0, mid)).width <= SAFE_WIDTH) {
          fit = mid;
          left = mid + 1;
        } else {
          right = mid - 1;
        }
      }

      pushLine(rest.slice(0, fit));
      rest = rest.slice(fit);

      if (lines.length === maxLines && rest.length > 0) {
        return true;
      }
    }

    return false;
  };

  const words = text.split(/\s+/);

  for (const word of words) {
    if (ctx.measureText(word).width > SAFE_WIDTH) {
      if (currentLine) {
        pushLine(currentLine);
        currentLine = '';

        if (lines.length === maxLines) {
          isTruncated = true;
          break;
        }
      }

      if (fitWord(word)) {
        isTruncated = true;
        break;
      }

      continue;
    }

    const candidate = currentLine ? `${currentLine} ${word}` : word;

    if (ctx.measureText(candidate).width <= SAFE_WIDTH) {
      currentLine = candidate;
      continue;
    }

    pushLine(currentLine);

    if (lines.length === maxLines) {
      isTruncated = true;
      break;
    }

    currentLine = word;
  }

  if (!isTruncated && currentLine) {
    lines.push(currentLine);
  }

  if (!isTruncated) {
    return lines.join('\n');
  }

  const lastLine = lines[maxLines - 1];

  let left = 0;
  let right = lastLine.length;
  let fit = 0;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);

    if (ctx.measureText(lastLine.slice(0, mid) + '…').width <= SAFE_WIDTH) {
      fit = mid;
      left = mid + 1;
    } else {
      right = mid - 1;
    }
  }

  lines[maxLines - 1] = lastLine.slice(0, fit) + '…';

  return lines.join('\n');
}
